export const baseUrl = "https://medicity.logiprompt.in/";
